import { createSlice } from "@reduxjs/toolkit";
import { fetchDatastreamList } from "./dashboard.thunk";

const datastreamState = { selected: null, list: [] };

const datastreamSlice = createSlice({
  name: "datastream",
  initialState: datastreamState,
  reducers: {
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDatastreamList.fulfilled, (state, action) => {
        state.list = action.payload;
      })
      .addCase(fetchDatastreamList.rejected, (state) => {
        state.list = [];
      });
  },
});

export const { setSelected } = datastreamSlice.actions;
export default datastreamSlice.reducer;
